import(/* webpackMode: "eager" */ "/home/ubuntu/download/6971ec011beda80014a5d09d/fusion_finishing_co_1769073665129/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6971ec011beda80014a5d09d/fusion_finishing_co_1769073665129/src/app/homepage/components/CapacityDashboard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6971ec011beda80014a5d09d/fusion_finishing_co_1769073665129/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/6971ec011beda80014a5d09d/fusion_finishing_co_1769073665129/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/6971ec011beda80014a5d09d/fusion_finishing_co_1769073665129/src/components/ui/AppImage.tsx");
